import HTTP from '../../Infra/Http'


 

export const getDashboardStats = async () => {
  return await HTTP.Get('/api/protected/dashboard/stats');
};
 

export const getAllUsers = async () => {
  return await HTTP.Get('/api/protected/users/all');
};
 



export const getAllPendingsStatus = async () => {
  return await HTTP.Get('/api/protected/reminders/report-pendings-status');
};

 export const getAllOtherStatus = async () => {
  return await HTTP.Get('/api/protected/reminders/report-other-status');
};


  export const getAllPaymentsReport = async () => {
  return await HTTP.Get('/api/protected/payments/report-all-payments');
};
